import React from "react";
import { useTranslation } from "react-i18next";
import { Logo } from "src/components/ui/logo";
import Text from "src/components/ui/text";

interface PagePreloaderProps {
  className?: string;
  style?: React.CSSProperties;
  text?: string;
}

const PagePreloader: React.FC<PagePreloaderProps> = (
  {
    className,
    style,
    text,
  },
) => {
  const { t } = useTranslation();
  const classNames = React.useMemo(() => {
    const classes = ["d-flex flex-column justify-content-center align-items-center"];
    if (className) {
      classes.push(className);
    }
    return classes.join(" ");
  }, [className]);

  const styles = React.useMemo(() => {
    const defaultStyle = {
      minHeight: "calc(80vh - 120px)",
    };

    if (!style) {
      return defaultStyle;
    }

    return {
      ...defaultStyle,
      ...style,
    };
  }, [style]);

  const loadingText = React.useMemo(() => {
    if (text) {
      return text;
    }

    return t("Loading");
  }, [text]);

  return (
    <div
      className={classNames}
      style={styles}
      title={loadingText}
    >
      <Logo showBeta={false} animated />
      <Text color="muted">
        {loadingText}
      </Text>
    </div>
  );
};

export default PagePreloader;
